export const supportedLocales = ["en-us", "es-es"];

export const baseUrl =
  process.env.NODE_ENV == "development"
    ? "https://localhost:8080"
    : "https://mail2self.com";

export const firebaseConfig = {
  apiKey: "AIzaSyCesZtI9JlHeWefLFJCaaKMjFNdDkr_Y1M",
  authDomain: "mail2self-58a4d.firebaseapp.com",
  databaseURL: "https://mail2self-58a4d.firebaseio.com",
  projectId: "mail2self-58a4d",
  storageBucket: "mail2self-58a4d.appspot.com",
  messagingSenderId: "203488581949",
  appId: "1:203488581949:web:e932ee04f65f84679e8d54",
  measurementId: "G-6XJY6JRLB3",
};
